import BreakdownDetailsModal from 'common/activeElements/modals/BreakdownDetailsModal';
import { MODAL_NAMES } from 'common/activeElements/modals/modalNames';
import { SIDEBAR_NAMES } from 'common/activeElements/sidebars/sidebarsNames';
import { notificationStore } from 'global/NotificationStore';

import AssignJobReturnSidebar from './components/AssignJobReturnSidebar';
import CreateBreakdownFlow from './components/CreateBreakdownFlow/CreateBreakdownFlow';
import ReturnJobDetailsSidebar from './components/ReturnJobDetailsSidebar';

export const PAGE_KEY = 'WorkAssignments';

/**
 * Builds the ActiveElements registry for the WorkAssignments page.
 *
 * `onBreakdownCreated(breakdown)` fires after a successful breakdown
 * mutation. The caller wires it to `store.upsertBreakdownByGroupId` so
 * the assignment list reflects the new breakdown inline, without a page
 * reload or a whole-list refetch.
 */
export const makeActiveElementsConfig = ({ onBreakdownCreated } = {}) => [
	{
		name: SIDEBAR_NAMES.assignJobReturn,
		Component: (props) => <AssignJobReturnSidebar {...props} />,
	},
	{
		name: SIDEBAR_NAMES.returnJobDetails,
		Component: (props) => <ReturnJobDetailsSidebar {...props} />,
	},
	{
		name: MODAL_NAMES.flow,
		Component: ({ onClose, assignment }) => (
			<CreateBreakdownFlow
				assignment={assignment}
				onSubmit={(breakdown) => {
					notificationStore.setNotification({
						header: 'Breakdown created',
						appearance: 'success',
					});
					if (breakdown) onBreakdownCreated?.(breakdown);
				}}
				onClose={onClose}
			/>
		),
	},
	{
		name: MODAL_NAMES.breakdownDetails,
		Component: (props) => <BreakdownDetailsModal {...props} />,
	},
];
